import Axios from "../redux/setupAxios";
import { Urls } from "../app/utils/constants";
import { microserviceNames } from "../app/utils/constants";

const proxyWithoutToken = microserviceNames.stakeholderMicroserviceWithoutToken;
const proxy = microserviceNames.stakeholderMicroservice;

export async function getCriteriasByIndustryCategoryId(industryCategoryId, gradeId) {
    return (await Axios.get(`${proxyWithoutToken}/${Urls.Criterias}/filter?category=${industryCategoryId}&grade=${gradeId}`)).data;
}

export async function getCriteriaById(id) {
    return (await Axios.get(`${proxyWithoutToken}/${Urls.Criterias}/${id}`)).data;
}

export async function getGradeCardDetails(industryCategory, industrySubCategory) {
    return (await Axios.get(`${proxy}/${Urls.Criterias}/card?industryCategory=${industryCategory}&industrySubCategory=${industrySubCategory}`)).data;
}